import React from "react";
import { motion } from "framer-motion";

export default function ProductCard({ product }) {
  return (
    <motion.div whileHover={{ scale: 1.04, y: -6 }} className="bg-black/40 border border-white/6 rounded-2xl p-5 neon-glow">
      <div className="h-44 flex items-center justify-center">
        <img src={product.image} alt={product.name} className="max-h-40 object-contain" />
      </div>
      <h3 className="mt-4 text-lg font-semibold text-gray-100">{product.name}</h3>
      <div className="flex items-center justify-between mt-2">
        <span className="text-[#00ffcc] font-bold">{product.price}</span>
        <button className="px-3 py-1 rounded-full bg-white/5 text-sm">View</button>
      </div>
    </motion.div>
  );
}
